export default __webpack_public_path__ + "static/14-binary-code-62f066a925bbe09b7a00514a39c11f48.png";